export default __webpack_public_path__ + "static/media/FincantieriSI_ZEUS_Project_April_2021.8cf330b3.pdf";